const { cELM, getAnswerVariableCssClass } = require("../utils");
const Scroller = require("../components/scroller");
const Block = require("../components/blocks/index");


class QuizLogicModule {
    constructor(type, value, parentRef) {
    this.type = type;
    this.value = value;
    this.parent = parentRef;
    const cssVariableKey = getAnswerVariableCssClass(value);
    this.elContainer = cELM("div", `quizlogic-module ${cssVariableKey}`);
    this.contentHash = {};
    this.index = 6;
    }

    handle(type, value) {
        
        const _elm = this.handleOnMessage(value);
        if (!_elm) return;
  
        this.elContainer.addELM(_elm);
        
        Scroller.scrollToElm(_elm, () => {
            _elm.focus();
          });
        
    }


    handleOnMessage(value) {
        let identifier = value.values.id;

        if (identifier.indexOf("/answer") > -1) {
            
            const idParts = identifier.split("/answer/");
            identifier = idParts[0] + "/" + idParts[1];

            const question = this.contentHash[identifier][1];
            question.updateAnswer(value.values)
            

        }
        else if (this.contentHash[identifier]) {
            component = this.mapFormat(value);
            this.contentHash[identifier] = [
                Object.keys(this.contentHash).length,
                component
            ];
        }
        else if (!this.contentHash[identifier]) {
            component = this.mapFormat(value);
            this.contentHash[identifier] = [
                Object.keys(this.contentHash).length,
                component
            ];
        }
        else {
            component = this.mapFormat(value);
            this.contentHash[identifier] = [
                Object.keys(this.contentHash).length,
                component
            ];
        }

        return component;
    }

    mapFormat(value) {
        const params = {
            data: value.values,
         };

        return new Block(params);
    }

    getHTML() {
    return this.elContainer;
    }

    getELM() {
        return this.elContainer;
    }
}
 

module.exports = QuizLogicModule;